/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PricingType } from './pricingType';


export interface UpdateLocationDto { 
    id?: number;
    code: string;
    name: string;
    address: string;
    phoneNumber: string;
    timeZoneId: string;
    taxType?: PricingType;
    tax?: number;
    serviceFeeType?: PricingType;
    serviceFee?: number;
    bannerImage?: string | null;
}
export namespace UpdateLocationDto {
}


